import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminAiLicences } from '../../services/getAdminAiLicences.service';

/** Loads the licence list: every licence row plus this month's charged businesses. */
export const loadAdminAiLicences = createAsyncThunk(
  'adminAi/loadAdminAiLicences',
  async (_, { rejectWithValue }) => {
    try {
      return await getAdminAiLicences();
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load AI licences');
    }
  }
);
